function getEnv(name: string): string {
    // @ts-ignore
    return window?.envConfig?.[name] || process.env[name] || "";
}

function getCulture(): string {
    return getEnv("VUE_APP_CULTURE");
}

function getApiBaseUrl(): string {
    return getEnv("VUE_APP_API_BASE_URL");
}

function getApiKey(): string {
    return getEnv("VUE_APP_API_KEY");
}

function getContactPhoneNumber(): string {
    return getEnv("VUE_APP_CONTACT_PHONE_NUMBER");
}

function getMappLink(): string {
    return getEnv("VUE_APP_MAPP_LINK");
}

function getEclientLink(): string {
    return getEnv("VUE_APP_ECLIENT_LINK");
}

export {
    getCulture,
    getApiBaseUrl,
    getApiKey,
    getContactPhoneNumber,
    getMappLink,
    getEclientLink
};
